// Key figures between two sections of a one page (scss/pages/_onepage.scss, .section-bridge): the card lies on the border
// of the two, its upper half over the one, its lower half over the other, so the background behind it is split in two.
// How far it reaches into its neighbours depends on its height (wrapping labels on a phone), so it is measured here:
// --bridge-half on the <main>, the neighbours make that much more room. Measured again when the card changes its size.
// Without JavaScript the key figures stay a plain band.
export default function initSectionBridge() {
    const main = document.querySelector('main.onepage');
    if (!main) {
        return;
    }

    // a key figures block with a block section before and after it (not the first block below the banner, not the last)
    const bridges = [...main.querySelectorAll(':scope > .section + .section:has(> .main-numbers)')]
        .filter((section) => section.nextElementSibling?.matches('section.section'));
    if (!bridges.length) {
        return;
    }

    bridges.forEach((section) => section.classList.add('section-bridge'));
    const cards = bridges.map((section) => section.firstElementChild);
    const measure = () => {
        const half = Math.ceil(Math.max(...cards.map((card) => card.offsetHeight)) / 2);
        main.style.setProperty('--bridge-half', `${half}px`);
    };

    measure();
    if (typeof ResizeObserver === 'function') {
        const observer = new ResizeObserver(measure);
        cards.forEach((card) => observer.observe(card));
    }
}
